module.exports = __webpack_public_path__ + "img/24_21.1ae633de.png";